import { apiFetchMutiCouponList } from '@/api/imee'

export const mixin = {
  data() {
    return {
      scene: this.$route.query.scene || null,

      // 优惠券
      maxCoupon: null,
      showCoupons: false,
      selectedCoupon: null,
      validCouponList: [],

      // 支付方式
      beforeOriginPayIndex: 1,

      payTypeLevelArr: null,
      showMore: false,
      currentPayTypeLevel: 0,
      lastPayTypeLevel: 0,

      // 支付结果
      showResultDia: false,
      payResultText: ''
    }
  },
  methods: {
    // 获取shopType
    // prettier-ignore
    getShopType () {
      // 路由参数无
      if (this.$route.query.shopType) {
        return this.$route.query.shopType
      }
      else {
        return this.scene == 'activity' ? 7 : null
      }
    },
    // 支付结果-客户端回调
    onNewIntent(url) {
      if (url) {
        let data = JSON.parse(url)
        if (data.status == 'PENDING') {
          this.payResultText = this.$t('lang.pay.resultPidding')
          this.showResultDia = true
        }
        if (data.status == 'FAILED') {
          this.payResultText = this.$t('lang.pay.resultFailed')
          this.showResultDia = true
        }
        if (data.status == 'CLOSED') {
          this.payResultText = 'Closed'
          this.showResultDia = true
        }
      }
    },

    // 支付结果-关闭弹窗
    cancelAgain() {
      this.showResultDia = false
    },

    initCoupon() {
      this.resetCoupon()

      // 初始化优惠券列表
      if (this.scene != 'activity') {
        const coinAmount = this.myPlus(this.amount, this.presentAmount)
        apiFetchMutiCouponList({ coinAmount }).then((resData) => {
          if (resData) {
            // 有效的
            this.validCouponList = resData.validCouponRecords || []
            this.findMaxCoupon(this.validCouponList, true)
          }
        })
      }
    },

    resetCoupon() {
      this.maxCoupon = null
      this.showCoupons = false
      this.selectedCoupon = null
      this.validCouponList = []
    },

    // 优惠券-找最优
    findMaxCoupon(couponList, useMax) {
      try {
        if (couponList && couponList.length) {
          const tempCoupon = couponList[0]
          if (tempCoupon.canUse === true) {
            this.maxCoupon = tempCoupon
            if (useMax) {
              this.selectedCoupon = tempCoupon
            }
          }
          //
          else {
            this.maxCoupon = null
            if (useMax) {
              this.selectedCoupon = null
            }
          }
        }
      } catch (err) {
        console.log('try catch err', err)
      }
    },

    // 优惠券-打开列表
    handleClickCouponEnter() {
      if (this.showCoupons) {
        this.showCoupons = false
        return
      }

      const hasCoupon = this.validCouponList && this.validCouponList.length
      if (hasCoupon) {
        const nowTime = Date.now()
        this.validCouponList.forEach((item) => {
          if (nowTime > item.expiredTime) {
            item.canUse = false
          }
        })

        this.validCouponList = this.validCouponList.filter((item) => item.canUse)

        if (this.selectedCoupon) {
          if (!this.validCouponList.some((couponItem) => couponItem.couponRecordId === this.selectedCoupon.couponRecordId)) {
            this.selectedCoupon = null
          }
        }
      }

      this.showCoupons = this.validCouponList && this.validCouponList.length
    },

    // 优惠券-选择
    handleSelectCoupon(item) {
      if (item && item.canUse === true) {
        this.selectedCoupon = item
      }
    },

    // 支付方式-默认选最优
    selectedBestPayType() {
      if (this.payList.length) {
        const bestIndex = this.payList.findIndex((item) => item.ifBestPrice)
        if (bestIndex > -1) {
          this.$nextTick(() => {
            this.handleSelectPay(this.payList[bestIndex], bestIndex)
          })
        }
      }
    },

    // 支付方式排序
    sortPayType() {
      if (this.payList.length) {
        // 处理最优 和 上次使用
        let bestIndex = this.payList.findIndex((item) => item.ifBestPrice)
        let lastUsedChannelIndex = this.payList.findIndex((item) => item.name === this.lastUsedChannel)
        let bestObj = null
        let lastUsedObj = null
        if (bestIndex > -1) {
          bestObj = this.payList[bestIndex]
          this.payList.splice(bestIndex, 1)
        }
        if (lastUsedChannelIndex > -1) {
          lastUsedObj = this.payList[lastUsedChannelIndex]
          this.payList.splice(lastUsedChannelIndex, 1)
        }

        if (lastUsedObj) {
          this.payList.unshift(lastUsedObj)
        }

        if (bestObj) {
          this.payList.unshift(bestObj)
        }

        // 处理原生支付位置
        // 1 最优 和 上次 都不存在
        if (!lastUsedObj && !bestObj) {
          this.beforeOriginPayIndex = -1
        }

        // 2 上次不存在
        if (bestObj && !lastUsedObj) {
          this.beforeOriginPayIndex = 0
        }

        // 3 上次支付存在
        // 上次支付 == 原生支付
        const originPayName = ['Apple Pay', 'Google Pay']
        if (lastUsedObj && originPayName.includes(lastUsedObj.name)) {
          const tempIndex = this.payList.findIndex((item) => item.name === bestObj.name)
          this.beforeOriginPayIndex = tempIndex
        }

        // 4 上次支付存在
        // 上次支付 != 原生支付
        if (lastUsedObj && !originPayName.includes(lastUsedObj.name)) {
          const tempIndex = this.payList.findIndex((item) => item.name === lastUsedObj.name)
          this.beforeOriginPayIndex = tempIndex
        }
      }
    },

    initMore() {
      if (this.payList && this.payList.length) {
        const levelArr = this.payList.map((item) => item.priority)
        const tempSet = new Set(levelArr)
        const tempArr = Array.from(tempSet)
        this.payTypeLevelArr = tempArr.sort((a, b) => a - b)

        if (this.payTypeLevelArr && this.payTypeLevelArr.length) {
          this.showMore = this.payTypeLevelArr.length > 1
          this.lastPayTypeLevel = this.payTypeLevelArr[this.payTypeLevelArr.length - 1]
        }
      }
    },

    // 支付方式
    showMorePay() {
      if (this.payTypeLevelArr && this.payTypeLevelArr.length) {
        const currentIndex = this.payTypeLevelArr.findIndex((item) => item === this.currentPayTypeLevel)
        if (currentIndex > -1) {
          // 展开
          if (currentIndex < this.payTypeLevelArr.length - 1) {
            this.currentPayTypeLevel = this.payTypeLevelArr[currentIndex + 1]
          }
          // 收起
          else {
            this.currentPayTypeLevel = this.payTypeLevelArr[0]
          }
        }
      }
    }
  },
  mounted() {
    window.onNewIntent = this.onNewIntent
  }
}
